import Vue from 'vue';
import VueOnToast from 'vue-on-toast'; // Growl-style toast notifications library. https://www.npmjs.com/package/vue-on-toast
import moment from 'moment';
import axios from 'axios';
import MAIcon from '@mapanything/ma-lib/src/vue/components/ma-icon';
import store from './store';
import router from './router';
import App from './App.vue';

// SLDS Styling
import '@salesforce-ux/design-system/assets/styles/salesforce-lightning-design-system.min.css';
import './assets/ma-icons-2/styles.css';
// Toast Styling (To be Changed to SLDS)
import 'vue-on-toast/dist/vue-on-toast.css';

Vue.config.productionTip = false;

Vue.component('MAIcon', MAIcon);

Vue.use(VueOnToast, moment);

const EventBus = new Vue();
window.VueEventBus = EventBus;

axios.interceptors.response.use((response) => response, (error) => {
    if (error instanceof Error) {
        return Promise.reject(error);
    }
    if (error.response.status === 401) {
        router.replace({});
        window.VueEventBus.$emit('reAuthenticate');
    }
    return Promise.reject(error);
});

Object.defineProperties(Vue.prototype, {
    $bus: {
        get() {
            return EventBus;
        }
    },
    $http: {
        get() {
            return axios;
        }
    },
    $moment: {
        get() {
            return moment;
        }
    }
});

new Vue({
    store,
    router,
    render: (h) => h(App)
}).$mount('#app');
